module.exports = __webpack_public_path__ + "img/background.46b2c225.jpg";